import React, { useEffect, useState } from 'react';
import { Input } from 'antd';
import { isTime } from './scheduleTimes';

// Native time inputs use the device's clock preference; text keeps HH:mm on every device.
export default function ScheduleTimeInput({ value, onChange, ...props }) {
  const [typed, setTyped] = useState(value || '');
  useEffect(() => setTyped(value || ''), [value]);
  return <Input {...props} type="text" inputMode="text" maxLength={5} placeholder="HH:mm" value={typed}
    onChange={event => {
      const next = event.target.value;
      setTyped(next);
      if (isTime(next) && next !== value) onChange(next);
    }}
    onBlur={() => { if (!isTime(typed)) setTyped(value || ''); }} />;
}